import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Save, RefreshCw } from "lucide-react";
import { CARD, INPUT, PRIMARY_BTN, OUTLINE_BTN } from "./adminStyles";

export const AdminProfileTab = ({ profile, setProfile, loading, onSave, onReset }) => {
  if (!profile) return null;
  const patch = (key, cast = (v) => v) => (e) => setProfile({ ...profile, [key]: cast(e.target.value) });
  const sliderPct = profile.revenueGoal ? Math.round((profile.currentRevenue / profile.revenueGoal) * 100) : 0;
  const onSlider = (e) => setProfile({ ...profile, currentRevenue: (profile.revenueGoal * Number(e.target.value)) / 100 });

  return (
    <Card className={`${CARD} p-6`} data-testid="admin-profile-tab">
      <h2 className="text-xl font-bold text-white mb-6">User Profile Quick Edit</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label className="text-gray-400">Company Name</Label>
          <Input value={profile.companyName || ""} onChange={patch("companyName")} className={INPUT} data-testid="profile-company-input" />
        </div>
        <div>
          <Label className="text-gray-400">Revenue Goal</Label>
          <Input type="number" value={profile.revenueGoal ?? ""} onChange={patch("revenueGoal", parseFloat)} className={INPUT} data-testid="profile-goal-input" />
        </div>
        <div>
          <Label className="text-gray-400">Current Revenue</Label>
          <Input type="number" value={profile.currentRevenue ?? ""} onChange={patch("currentRevenue", parseFloat)} className={INPUT} data-testid="profile-revenue-input" />
        </div>
        <div>
          <Label className="text-gray-400">Revenue % (Slider)</Label>
          <div className="flex items-center gap-4">
            <input type="range" min="0" max="100" value={sliderPct} onChange={onSlider} className="flex-1" data-testid="profile-revenue-slider" />
            <span className="text-white font-semibold w-16">{sliderPct}%</span>
          </div>
        </div>
        <div className="md:col-span-2">
          <Label className="text-gray-400">Products</Label>
          <Textarea value={profile.products || ""} onChange={patch("products")} className={`${INPUT} min-h-[100px]`} data-testid="profile-products-input" />
        </div>
        <div className="md:col-span-2">
          <Label className="text-gray-400">ICP</Label>
          <Textarea value={profile.icp || ""} onChange={patch("icp")} className={`${INPUT} min-h-[100px]`} data-testid="profile-icp-input" />
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <Button onClick={onSave} disabled={loading} className={PRIMARY_BTN} data-testid="save-profile-btn">
          <Save className="h-4 w-4 mr-2" /> Save Changes
        </Button>
        <Button onClick={onReset} variant="outline" className={OUTLINE_BTN} data-testid="reset-profile-btn">
          <RefreshCw className="h-4 w-4 mr-2" /> Reset
        </Button>
      </div>
    </Card>
  );
};
